import { Component, Input, OnInit } from '@angular/core';
import { IROPS_STATUS } from '@app/enums/irops.enum';
import { Reservation } from '@app/models/micro';
import { GlobalsService } from '@app/services/micro/globals.service';
import {
  calculateTimeFlight,
  getSabreArrivalDate,
  getSabreDepartureDate,
  getSegmentArrivalDate,
  getSegmentDepartureDate,
  parseTime,
} from '@app/utils/functions/srIrops';

@Component({
    selector: 'itinerary-early-irops-rebrand',
    templateUrl: './itinerary-early-irops-rebrand.component.html',
    styleUrls: ['./itinerary-early-irops-rebrand.component.scss'],
    standalone: false
})
export class ItineraryEarlyIropsRebrandComponent implements OnInit {
  @Input() statusIrops: IROPS_STATUS;
  @Input() segModify: any;
  @Input() firstSegment: any;
  @Input() lastSegment: any;
  @Input() firstAfected: any;
  @Input() itinerary: any;
  @Input() lineRoute: any;
  @Input() firstAfectedTime: any;
  @Input() scales: any;
  @Input() isAfectedFirstSeg: any;
  @Input() isAfectedLastSeg: any;
  @Input() segments: any;
  reservation: Reservation;

  constructor(private _globalsService: GlobalsService) { }

  ngOnInit() {
    this.reservation = this._globalsService.getReservation();
  }

  get changeCopyBanner() {
    if(!this.reservation?.isEmployee) {
      return 'srIrops.IropsBannerCancelledFlightR';
    } else {
      return 'srIrops.isEmployee';
    }
  }

  get dateDeparture() {
    return getSabreDepartureDate(this.firstSegment);
  }

  get dateArrival() {
    return getSabreArrivalDate(this.lastSegment);
  }

  get timeItinerary() {
    return parseTime(
      getSabreDepartureDate(this.firstSegment),
      getSabreArrivalDate(this.lastSegment)
    );
  }

  get timeConnecting() {
    return calculateTimeFlight(
      getSegmentArrivalDate(this.firstSegment),
      getSegmentDepartureDate(this.lastSegment)
    );
  }

  get duration() {
    return calculateTimeFlight(
      getSabreDepartureDate(this.firstSegment),
      getSabreArrivalDate(this.lastSegment)
    );
  }

}